/**
 * Formats a date string to YYYYMMDD format
 * @param dateString - Date string to format
 * @returns Formatted date string or 'N/A' if invalid
 */
export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) return 'N/A';

  const date = new Date(dateString);
  if (isNaN(date.getTime())) return 'Invalid date';

  return date.toISOString().split('T')[0].replace(/-/g, '');
};

/**
 * Formats a price number to Swedish currency format
 * @param price - Price number to format
 * @returns Formatted price string with 'kr' suffix
 */
export const formatPrice = (price: number): string => {
  return `${price} kr`;
};
